// import components
import { Tooltip } from 'components/shared';
import { GridContainerFieldArrayDrawer } from 'components/shared/Grid/Grid.components';
import DrawerFooter from 'components/shared/Drawer/DrawerFooter';
import { Button } from '@mui/material';

// import context
import { useFieldArrayContext } from '../hooks/useFieldArrayContext';

// import external libraries
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FieldArrayWithId } from 'react-hook-form/dist/types/fieldArray';
import { useTranslation } from 'react-i18next';

// import hooks
import useFindIndexFromFieldsArray from 'components/shared/CRUD/hooks/useFindIndexFromFieldsArray';

// import styles
import {
  StyledWithFieldArrayDrawerBox,
  StyledWithFieldArrayDrawerFooterBox
} from './withFieldArrayDrawer.styles';

// import types
import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import { Icon } from '@sdb/planning-ui';

const getLastAddedFieldId = (fields: FieldArrayWithId[]) =>
  fields.slice(-1)[0]?.id;

const withFieldArrayDrawer =
  (Component: React.FC<any>, fieldArrayId: string) =>
  (props: FormComponentProps & any) => {
    const { t } = useTranslation('common');
    const { getValues, trigger } = useFormContext();
    const { fields, update } = useFieldArrayContext();
    const fieldIndex = useFindIndexFromFieldsArray(
      props.rowId ?? getLastAddedFieldId(fields),
      fields
    );

    const fieldId = `${fieldArrayId}[${fieldIndex}]`;

    return (
      <>
        <GridContainerFieldArrayDrawer>
          <StyledWithFieldArrayDrawerBox>
            <Component {...props} />
          </StyledWithFieldArrayDrawerBox>
        </GridContainerFieldArrayDrawer>
        <StyledWithFieldArrayDrawerFooterBox>
          <DrawerFooter>
            <Tooltip title={props.rowId ? t('save') : t('addToList')}>
              <Button
                variant="contained"
                color="primary"
                onClick={async () => {
                  // onPreSubmit && (await onPreSubmit(fieldId, fields, context));
                  trigger(fieldId).then((isValid) => {
                    if (isValid) {
                      update(fieldIndex, {
                        ...getValues(fieldId),
                        isCommitted: true
                      });
                      props.handleClose();
                    }
                  });
                }}
              >
                <Icon type="check" />
              </Button>
            </Tooltip>
          </DrawerFooter>
        </StyledWithFieldArrayDrawerFooterBox>
      </>
    );
  };

export default withFieldArrayDrawer;
